"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _Header = _interopRequireDefault(require("./Header"));
var _Combobox = _interopRequireDefault(require("./Combobox"));
function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];
  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }
  return arr;
}
var Panel = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Panel, _Component);
  var _super = (0, _createSuper2["default"])(Panel);
  function Panel(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Panel);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (newValue) {
      _this.setState({
        value: newValue
      });
      _this.props.onChange(newValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "disabledHours", function () {
      var _this$props = _this.props,
        use12Hours = _this$props.use12Hours,
        disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();
      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }
      return disabledOptions;
    });
    _this.state = {
      value: props.value,
      selectionRange: []
    };
    return _this;
  }
  (0, _createClass2["default"])(Panel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;
      if (value) {
        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.props.onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var value = this.state.value || this.props.defaultOpenValue;
      return value.hour() >= 0 && value.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props2 = this.props,
        prefixCls = _this$props2.prefixCls,
        className = _this$props2.className,
        placeholder = _this$props2.placeholder,
        disabledMinutes = _this$props2.disabledMinutes,
        disabledSeconds = _this$props2.disabledSeconds,
        hideDisabledOptions = _this$props2.hideDisabledOptions,
        allowEmpty = _this$props2.allowEmpty,
        showHour = _this$props2.showHour,
        showMinute = _this$props2.showMinute,
        showSecond = _this$props2.showSecond,
        format = _this$props2.format,
        defaultOpenValue = _this$props2.defaultOpenValue,
        clearText = _this$props2.clearText,
        onEsc = _this$props2.onEsc,
        addon = _this$props2.addon,
        use12Hours = _this$props2.use12Hours,
        onClear = _this$props2.onClear,
        focusOnOpen = _this$props2.focusOnOpen,
        onKeyDown = _this$props2.onKeyDown,
        hourStep = _this$props2.hourStep,
        minuteStep = _this$props2.minuteStep,
        secondStep = _this$props2.secondStep,
        inputReadOnly = _this$props2.inputReadOnly,
        clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
        value = _this$state.value,
        currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-inner"), true), (0, _defineProperty2["default"])(_classNames, className, !!className), _classNames))
      }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: defaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        onClear: onClear,
        allowEmpty: allowEmpty,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), /*#__PURE__*/_react["default"].createElement(_Combobox["default"], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: defaultOpenValue,
        format: format,
        onChange: this.onChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        isAM: this.isAM()
      }), addon(this));
    }
  }]);
  return Panel;
}(_react.Component);
(0, _defineProperty2["default"])(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: _noop["default"],
  onClear: _noop["default"],
  disabledHours: _noop["default"],
  disabledMinutes: _noop["default"],
  disabledSeconds: _noop["default"],
  defaultOpenValue: (0, _moment["default"])(),
  use12Hours: false,
  addon: _noop["default"],
  onKeyDown: _noop["default"],
  inputReadOnly: false
});
var _default = Panel;
exports["default"] = _default;